import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FileUploader } from 'ng2-file-upload';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';


@Component({
    selector: 'file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
    standalone: false
})
export class FileUploaderComponent {
  @Input()
  uploadUrl?: string;

  @Input()
  customText?: string;

  @Input()
  displayUseAsPrintFileCheckbox?: boolean;


  @Output()
  fileUploaded: EventEmitter<any> = new EventEmitter();


  public uploading: boolean = false;
  public uploadingComplete: boolean = false;

  public uploader?: FileUploader;
  fileOverDropZone: any = null;

  useAsPrintFile: boolean = false;

  @ViewChild('fileInput')
  fileInput?: ElementRef<HTMLInputElement>;

  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }


  async initUploader() {
    this.uploader = new FileUploader({
      url: this.api.storeUrl(`${this.uploadUrl}`),
      autoUpload: true,
      method: 'post',
      itemAlias: 'file',
      headers: [
        {
          name: 'Access-Code',
          value: this.globals.accessCode as string
        }
      ]
    });


    this.uploader.onSuccessItem = (item, response, status, headers) => {
      console.log('Success item');
      console.log(item);
      let data = JSON.parse(response);
      if (data.succeeded) {
        this.fileUploaded.emit(data);
      }

      this.uploading = false;

    }

    this.uploader.onErrorItem = (item, response, status, headers) => {
      console.log('Error item');
      console.log(item);

      this.uploading = false;

    }

    console.log('Uploader initialized');
    console.log(this.uploader);
  }

  async ngOnInit() {
    await this.initUploader();
  }

  async ngOnChanges() {
    await this.initUploader();
  }


  public fileOver(e: any): void {
    this.fileOverDropZone = e;
  }



  public fileDropped(e: any): void {
    console.log('Files dropped');
    console.log(e);

    this.uploading = true;
  }

  openFileSelect() {
    this.fileInput?.nativeElement.click();
  }


}


